module.exports = __webpack_public_path__ + "static/media/feature2partner.fef1cb8c.png";